import React, { useState } from 'react';
import image from './images/fs22.png';
import "./Header.css";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Link, useNavigate } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { useUserAuth } from './UserAuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';

function Header() {
  const { logOut, user } = useUserAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };
  const [{ basket }, dispatch] = useStateValue();
  const [showSideMenu, setShowSideMenu] = useState(false); // State to control the side menu visibility

  const link = {
    textDecoration: 'none', // Wrap the property name in quotes
    color: 'white',         // Wrap the property name in quotes
  };

  const signout = {
    display: 'flex',
     fontSize: '13px',
  }

  if (window.innerWidth <= 600) {
    link.color = 'black';
  }
  if (window.innerWidth <= 600){
    signout.backgroundColor = 'black';
    signout.padding = '6px';
    signout.borderRadius = '10px';
  }
  

  const toggleSideMenu = () => {
    setShowSideMenu(!showSideMenu);
    // Set right and left properties based on showSideMenu state
    if (showSideMenu) {
      // Close the menu
      document.getElementById("sidemenu").style.left = "-200px";
    } else {
      // Open the menu
      document.getElementById("sidemenu").style.left = "0";
    }
  };

  return (
    <div className="header">
         <div className = "headmenuicon" onClick={toggleSideMenu}>
          <MenuIcon className="open"/>
        </div>
      <Link to="/home">
        <img className="header__logo" src={image} alt="" />
      </Link>
      <div className="header__search">
        <input placeholder="Search the shop..." className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>
      <div className="header__nav">
        <ul id="sidemenu">
        <li className="closeicon">
            <CloseIcon onClick={toggleSideMenu} />
          </li>
          <li>
            <div className = "opt" style={{ fontSize: '13px' }}>
              <h3>Returns & Orders</h3>
            </div>
          </li>
          <li>
            <div style={{ fontSize: '13px' }} className = "opt link">
              <a style = {link} href = "https://janardhan-ykunta.web.app/" target='_blank'><h3>Creator's Page</h3></a>
            </div>
          </li>
          <li>
            <div style = {signout} className = "opt signout" onClick={handleLogout}>
              <div ><h3>{user ? 'Sign Out' : 'Sign In'}&nbsp;</h3></div><div>{user ? <LogoutIcon/> : <LoginIcon/>}</div>
            </div>
          </li>
        </ul>
      </div>
      <Link className="custom-link" to="/checkout">
        <div className='header__optionBasket'>
          <ShoppingBasketIcon />
          <span className="header__optionLineTwo header__basketCount">{basket?.length}</span>
        </div>
      </Link>
    </div>
  );
}

export default Header;
